/**
 * Makes sure single values are wrapped in an array
 */
export function coerceArray<T>(value: T | T[]): T[] {
  return Array.isArray(value) ? value : [value];
}

/**
 * Makes sure the value is an array or return an empty array
 */
export function ensureArray<T>(value: T | T[] | null | undefined): T[] {
  return Array.isArray(value) ? value : [];
}
